import React from 'react';

const InstructionsContent = () => {
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {/* Step 1 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            1
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Upload Documents
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Use drag & drop or directory selection
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            2
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Extract Values
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Process documents and extract field data
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            3
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Analyze Data
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Review matches and discrepancies (optional)
            </div>
          </div>
        </div>

        {/* Step 4 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            4
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Save to Database
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Create loan record and activate action menu
            </div>
          </div>
        </div>
      </div>
      
      <div style={{ 
        background: 'rgba(255, 255, 255, 0.05)', 
        borderRadius: '8px', 
        padding: '1rem',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        marginTop: '1.5rem'
      }}>
        <div style={{ fontSize: '0.875rem', color: '#a0a0a0', textAlign: 'center' }}>
          💡 Use the action buttons in the main content area to process your documents
        </div>
      </div>
    </>
  );
};

export default InstructionsContent;
